import { ViewStyle } from 'react-native'

import { SPACING } from '@common/styles/spacings'

import { splitAnchor, ToastAnchor } from './config'

/**
 * Container for the toast list. Derived from the anchor rather than hardcoded
 * per position, so every value of ToastAnchor works without extra branches.
 *
 * `pointerEvents: 'box-none'` matters: the container is a large absolutely
 * positioned box, and without it every click behind it is swallowed while a
 * toast is up. Each card re-enables `pointerEvents: 'auto'` on itself.
 */
export const getContainerStyle = (
  anchor: ToastAnchor,
  offsets: { top: number; bottom: number }
): ViewStyle => {
  const [edge, align] = splitAnchor(anchor)

  const base: ViewStyle = {
    position: 'absolute',
    zIndex: 999,
    elevation: 20,
    pointerEvents: 'box-none',
    ...(edge === 'top' ? { top: offsets.top } : { bottom: offsets.bottom })
  }

  if (align === 'center') {
    return {
      ...base,
      // Not width: '100%' — inside a padded parent that measures the content
      // box but positions from the padding box, which overflows.
      left: 0,
      right: 0,
      alignItems: 'center',
      paddingHorizontal: SPACING
    }
  }

  // Left/right anchors omit the opposite edge so the box shrink-wraps the card.
  return {
    ...base,
    [align]: SPACING,
    alignItems: align === 'left' ? 'flex-start' : 'flex-end'
  }
}
